import { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X, Phone } from "lucide-react";

const NUMBERS = [
  { label: "Commerciale", n: "+39 351 926 1622" },
  { label: "Amministrazione", n: "+39 338 468 8841" },
  { label: "Segreteria", n: "+39 327 672 0303" },
];

export default function FloatingWhatsApp() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", onClick);
    document.addEventListener("keydown", onKey);
    return () => { document.removeEventListener("mousedown", onClick); document.removeEventListener("keydown", onKey); };
  }, [open]);

  return (
    <div ref={ref} className="fixed bottom-[88px] right-5 z-[120] flex flex-col items-end gap-3" data-testid="floating-whatsapp">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 16, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 16, scale: 0.95 }}
            transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
            className="w-[280px] bg-card border border-border shadow-xl"
          >
            <div className="bg-[#25D366] px-5 py-4 flex items-center gap-3">
              <MessageCircle className="w-6 h-6 text-white" />
              <div>
                <p className="font-head font-bold text-white leading-none">WhatsApp</p>
                <p className="font-mono text-[10px] uppercase tracking-widest text-white/80 mt-1">Rispondiamo subito</p>
              </div>
            </div>
            <div className="p-3">
              {NUMBERS.map((item) => (
                <a
                  key={item.n}
                  href={`https://wa.me/${item.n.replace(/[^0-9]/g, "")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`whatsapp-float-${item.n.replace(/[^0-9]/g, "")}`}
                  className="group flex items-center gap-3 px-3 py-3 hover:bg-secondary transition-colors"
                >
                  <span className="w-9 h-9 grid place-items-center bg-[#25D366]/10 text-[#128C7E] shrink-0">
                    <Phone className="w-4 h-4" />
                  </span>
                  <span className="min-w-0">
                    <span className="block font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{item.label}</span>
                    <span className="block font-medium text-sm truncate group-hover:text-[#128C7E] transition-colors">{item.n}</span>
                  </span>
                </a>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="whatsapp-toggle"
        aria-label="Contattaci su WhatsApp"
        className="relative w-14 h-14 grid place-items-center bg-[#25D366] text-white shadow-lg hover:scale-105 active:scale-95 transition-transform"
      >
        {!open && <span className="absolute inline-flex h-full w-full animate-ping rounded-none bg-[#25D366] opacity-30" />}
        {open ? <X className="w-7 h-7 relative" /> : <MessageCircle className="w-7 h-7 relative" />}
      </button>
    </div>
  );
}
